import {  Component,  EventEmitter, OnChanges,  OnInit, Output, SimpleChanges, } from '@angular/core';
import { SharedDataService, SuppliersService,PafListsService } from '../../all-services';
import {  WFMotif, Supplier, SupplierUpdateComment, SupplierStatut, SupplierWfAndContact} from '../../all-models';
import {  WindowRef } from '@progress/kendo-angular-dialog';
import { forkJoin } from 'rxjs';



export class HistoryLine {
  public Id: number = 0;
  public Date: Date;
  public IdPrec: number = 0;
  public StatutId: number = 0;
  public StatutIdPrec: number = 0;
  public StatutPrec: string = '';
  public StatutActuel: string = '';
  public Valideur: string = '';
  public WfMotif: WFMotif = null;
  public Observations: string = '';
  public StatutCod: string='';
  public StatutCodPrec:string='';
  public forward?: boolean = null;
  public PaddingLeft: number = 0;
  public WfMotifLibre: string = null;
}

@Component({
  selector: 'supplier-workflow',
  templateUrl: './supplier-workflow.component.html',
  styleUrls: ['./supplier-workflow.component.scss']
})
export class SupplierWorkflowComponent implements OnInit,OnChanges {
  @Output() onClose?:EventEmitter<void>=new EventEmitter<void>();

  public supplierWFs: SupplierWfAndContact[] = [];
  public historyLines: HistoryLine[] = [];
  public lstWFMotifs: WFMotif[] = [];
  public lstStatuts :SupplierStatut[] = [];
  public supplier?:Supplier=null;
  private _supplierId:number=0;
  public get supplierId():number{
    return this._supplierId;
  }
  public set supplierId(value:number){
    if (value!=this._supplierId){
      this._supplierId=value;
      this.reloadHistory();
    }
  }

  constructor(
    public window : WindowRef,
    private suppliersSvc: SuppliersService,
    private pafLists: PafListsService,
    public sharedDataSvc: SharedDataService) { }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['supplierId']){
      this.reloadHistory();
    }
  }

  closeWindow():void {
    this.window.close();
  }

  ngOnInit(): void {
  }



  reloadHistory(): void {
    this.historyLines = [];
    if (!this.supplierId) {
      return; 
    }
    this.sharedDataSvc.WindowLock();
    forkJoin([
      this.suppliersSvc.GetAllWorkFlow(this.supplierId),
      this.pafLists.getWFMotifs(),
      this.suppliersSvc.getSupplier(this.supplierId),
      this.pafLists.getSupplierStatuts()
    ]).subscribe(results=> {
        this.supplierWFs = results[0];
        this.lstWFMotifs = results[1];
        this.supplier=results[2];
        this.lstStatuts = results[3];
        this.supplierWFs.forEach((wf: SupplierWfAndContact) => {
          let line: HistoryLine = new HistoryLine();
          line.Id = wf.SupplierWF.Id;
          line.StatutId = wf.SupplierWF.StatutId;
          line.Date = wf.SupplierWF.DateStatut;
          line.WfMotif = this.lstWFMotifs.find(m => m.Id == wf.SupplierWF.WFMotifId);
          line.Valideur = wf.Contact?.EmailDiff || wf.Contact?.Email;
          line.Observations = wf.SupplierWF.Comments ? wf.SupplierWF.Comments : '';
          line.StatutCod = this.lstStatuts.find(st=>st.Id==wf.SupplierWF.StatutId)?.Cod;  
          this.addWfMotifLibre(line);
          this.historyLines.push(line);
        });
        //Maj statut precedent de chaque line
        this.historyLines.forEach((line: HistoryLine) => {
          let idPrec: number = Math.max.apply(null, this.historyLines.filter(hl => hl.Id < line.Id).map(hl => hl.Id)) || 0;
          line.IdPrec = isNaN(idPrec) ? 0 : idPrec;
          const linePrec: HistoryLine = this.historyLines.find(hl => hl.Id == line.IdPrec);
          line.StatutIdPrec = linePrec ? linePrec.StatutId : 0;
          line.StatutPrec = linePrec ? linePrec.StatutActuel : '';
          line.StatutCodPrec = linePrec ? linePrec.StatutCod:'';
          if (line.IdPrec>0){
            line.forward = line.StatutCod > (line.StatutCodPrec||'000');
          } 
          if ((line.forward==null || line.forward==true)){
            line.PaddingLeft = (<number>(line.StatutCodPrec||0)/10); 
          } else     {
            line.PaddingLeft = (<number>(line.StatutCod||0)/10); 
          }
        });
        this.historyLines.sortObjectDesc('Id');
        this.supplier.SupplierUpdateComments.forEach(c=>c.UpdateDate = new Date(c.UpdateDate));
        this.supplier.SupplierUpdateComments.sortOnDateDesc('UpdateDate');
        this.sharedDataSvc.WindowUnlock();
      });
  }

  addWfMotifLibre(line: HistoryLine):void {
    if (line.WfMotif?.Cod=='Duplication_Fournisseur') {
      line.WfMotifLibre = this.supplier.duplicatedComments;
      line.WfMotif = null;
    }
  }

  auteurCommentaire(comment:SupplierUpdateComment):string{
    if (!comment?.Contact) return '';
    return comment.Contact.EmailDiff || comment.Contact.Email;
  }

  showRightArrow(line:HistoryLine):boolean{
    return line.StatutIdPrec && line.StatutCodPrec<line.StatutCod;
  }
  
  showLeftArrow(line:HistoryLine):boolean{
    return line.StatutIdPrec && line.StatutCodPrec>line.StatutCod;
  }
}
